import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
import { useMerchantId } from '@/hooks/useMerchantId';
import { useAuth } from '@/context/AuthContext';

/** FR-64: `/branches` is scoped by session, no merchant_id param needed. */
export function useBranches() {
  const { merchantId } = useMerchantId();
  return useQuery({
    queryKey: ['branches', merchantId],
    queryFn: async () => {
      const { data, error } = await apiClient.GET('/branches');
      if (error) throw error;
      return data?.data ?? [];
    },
    enabled: !!merchantId,
  });
}

/**
 * FR-93/94: the branch a sale, shift or murabaha case belongs to — the cashier's
 * own branch (Lovable: profiles.branch_id), else the merchant's first active one.
 */
export function useCashierBranchId(): number | undefined {
  const { user } = useAuth();
  const { data: branches = [] } = useBranches();
  const active = branches.filter((b: { is_active: boolean }) => b.is_active);
  const own = active.find((b: { id: number }) => b.id === user?.branch_id);
  return (own ?? active[0] ?? branches[0])?.id;
}
